import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-fee-reports',
  templateUrl: './fee-reports.component.html',
  styleUrls: ['./fee-reports.component.scss'],
})
export class FeeReportsComponent implements OnInit {
  FeeDetailForm: FormGroup;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  feeList: any;
  filteredfeeList: any;
  sessionList: any[];
  SessionFilterList: any[];
  FeeData = [];
  filteredcourseList: any;
  courseList: any;
  filteredCollegeList: any;
  collegeList: any;
  AdmList = false;
  ExmList = false
  Table = false;
  TotalFees: any;
  TotalPaid: any;
  examList: any;
  filteredListExam: any;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public datepipe: DatePipe,
    private location: Location,
    private dialog: MatDialog,
    public router: Router
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.AdmList = false;
    this.ExmList = false
    this.FeeData = [];
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    this.FeeDetailForm = this.fb.group({
      FeeType: new FormControl('', Validators.required),
      SnNo: new FormControl('', Validators.required),
      CgCode: new FormControl(''),
      EmId: new FormControl(''),
      CoCode: new FormControl(''),
    });
    this.fetchFeeType();
    this.fetchSession();
    this.getCourseData();
  }

  fetchFeeType() {
    const payload = {};
    payload['CdType'] = 'FT';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.feeList = res.data;
          this.filteredfeeList = this.feeList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        // this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe((res) => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach((element) => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    });
  }

  getCollegeData(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.courseClg(payload).subscribe(
      (res) => {
        this.spinner.hide();
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      },
      (ERROR: HttpErrorResponse) => {
        this.collegeList = [];
        this.spinner.hide();
      }
    );
  }

  getCourseData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(
      (res) => {
        this.spinner.hide();
        this.courseList = res.data;
        this.filteredcourseList = this.courseList.slice();
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.courseList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  getData() {
    this.spinner.show()
    if(this.ExmList == true){
      this.FeeDetailForm.get('EmId').setValidators([Validators.required]);
      this.FeeDetailForm.get('EmId').updateValueAndValidity();
      this.FeeDetailForm.get('EmId').markAsTouched();
    }
    
    if (this.FeeDetailForm.invalid) {
      this.spinner.hide()
      if(this.ExmList == true){
        this.FeeDetailForm.get('EmId').setValidators([Validators.required]);
        this.FeeDetailForm.get('EmId').updateValueAndValidity();
        this.FeeDetailForm.get('EmId').markAsTouched();
      }
      this.FeeDetailForm.get('FeeType').markAsTouched();
      this.FeeDetailForm.get('SnNo').markAsTouched();
      return;
    } else {
      // this.spinner.hide()
      this.getList();
      this.unpaidFeeReport();
    }
  }

  getList(){
    this.spinner.show()
    if(this.FeeDetailForm.value['FeeType'] == 'AF'){
      // this.spinner.hide()
      this.getAdmList()
    }
    else if(this.FeeDetailForm.value['FeeType'] == 'EF'){
      // this.spinner.hide()
      this.getExmList()
    }
    else{
      this.spinner.hide()
    }
    
  }

  getListforExam(){
    if(this.FeeDetailForm.value['FeeType'] == 'AF'){
      this.AdmList = true;
      this.ExmList = false
    }
    else if(this.FeeDetailForm.value['FeeType'] == 'EF'){
      this.AdmList = false;
      this.ExmList = true
      this.getExam();
    }
  }

  getExam(){
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = this.FeeDetailForm.value['CoCode'];
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.examList = [];
        this.filteredListExam = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.examList = [];
      this.filteredListExam = [];
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }

  getExmList(){
    this.spinner.show();
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = submitpayload.CgCode;
    payload['CoCode'] = submitpayload.CoCode;
    payload['StuId'] = 0;
    payload['EmId'] = submitpayload.EmId
    payload2['SessionId'] = submitpayload.SnNo;
    payload2['CoCode'] = submitpayload.CoCode;
    payload2['CgCode'] = submitpayload.CgCode;
    payload2['StuId'] = 0;
    payload2['FeeType'] = 'EF';
    payload2['EmId'] = submitpayload.EmId

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          // this.Table = true;
          this.spinner.hide();
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];

          const paidStuIds = new Set(paidFeeData.map(item => item.StuId));

          // Call the second API for unpaid fees
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if(unpaidRes.status){
                
                const studentData = unpaidRes.data;

                // Filter out students already in paid fees
                const filteredUnpaidData = studentData.filter(record => !paidStuIds.has(record.StuId));
  
                const studentMap = new Map<number, any>();
                filteredUnpaidData.forEach(record => {
                  const key = record.StuId;
                  if (!studentMap.has(key)) {
                    studentMap.set(key, record);
                  }
                });
                  const FeeData = Array.from(studentMap.values()).map((item) => {
                    return {
                      ...item,
                      FeeAmt: '-',
                      TotalPaidAmount: item.TotalPaidAmount || 0, // Use existing value or default to 0
                      FeeTemplateCode: '-',
                    };
                  });
                  this.FeeData = [...paidFeeData,...FeeData];
                  this.Table = true
              }
              else{
                this.FeeData = [...paidFeeData];
                this.Table = true;
              }
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if(unpaidRes.status){
                
                const studentData = unpaidRes.data;
                  const studentMap = new Map<number, any>();
                  studentData.forEach(record => {
                    const key = record.StuId;
                    if (!studentMap.has(key)) {
                      studentMap.set(key, record);
                    }
                  });
                  const FeeData = Array.from(studentMap.values()).map((item) => {
                    return {
                      ...item,
                      FeeAmt: '-',
                      TotalPaidAmount: item.TotalPaidAmount || 0, // Use existing value or default to 0
                      FeeTemplateCode: item.TemplateCode || '-',
                    };
                  });
                  this.FeeData = [...FeeData];
                  // this.TotalPaid = this.calculateTotalPaidAmount(this.FeeData);
                  this.Table = true
                  
              } else {
                this.Table = false;
                this.showNoDataFound();
                this.spinner.hide();
              }
            },
            (error: HttpErrorResponse) => {
              this.spinner.hide();
              this.Table = false;
              this.showErrorPopup(error.error.message);
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.Table = false;
        this.showErrorPopup(error.error.message);
      }
    );
   
  }

  calculateTotalPaidAmount(data: any[]): number {
    return data.reduce((sum, item) => {
      const amount = typeof item.TotalPaidAmount === 'number' ? item.TotalPaidAmount : 0;
      return sum + amount;
    }, 0);
  }

  getAdmList() {
    this.spinner.show()
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = submitpayload.CgCode;
    payload['CoCode'] = submitpayload.CoCode;
    payload['StuId'] = 0;
    payload2['FeeType'] = submitpayload.FeeType;
    payload2['SnNo'] = submitpayload.SnNo;
    payload2['CgCode'] = submitpayload.CgCode;
    payload2['CoCode'] = submitpayload.CoCode;

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.Table = true;
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];

          // Call the second API for unpaid fees
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });

                // Combine the data from both APIs
                this.FeeData = [...paidFeeData, ...unpaidFeeData];
                this.Table = true;
                this.spinner.hide()
              }
              else{
                this.FeeData = [...paidFeeData];
                this.Table = true;
                this.spinner.hide()
              }
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });

                // Combine the data from both APIs
                this.FeeData = [...unpaidFeeData];
                this.Table = true;
                this.spinner.hide()
              } else {
                this.Table = false;
                this.spinner.hide()
                this.showNoDataFound();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              this.spinner.hide()
              this.showErrorPopup(error.error.message);
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide()
        this.showErrorPopup(error.error.message);
      }
    );
  }

  showNoDataFound() {
    let data = {};
    this.TotalFees = 0;
    this.TotalPaid = 0;
    data['message'] = 'No Data Found';
    data['title'] = 'Information';
    data['icon'] = 'fas fa-box-open';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
      AlertBoxComponent,
      data
    );
  }

  showErrorPopup(message: string) {
    let data = {};
    data['message'] = message;
    data['title'] = 'Information';
    data['icon'] = 'fas fa-box-open';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
      AlertBoxComponent,
      data
    );
  }

  back() {
    this.ngOnInit();
  }

  Back1() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  unpaidFeeReport() {
    this.spinner.show();
    this.FeeData = [];
    const payload = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = submitpayload.CgCode;
    payload['CoCode'] = submitpayload.CoCode;
    this.umsService.unpaidFeeReport(payload).subscribe((res) => {
      this.spinner.hide();
        if (res.status) {
          console.log('unpaid fees', res.data);
        } else {
        }
      },
      (ERROR: HttpErrorResponse) => {
        // this.spinner.hide();
        this.Table = false;
      }
    );
  }


  download3(event: Event) {
    event.preventDefault();
    const payload = {};
// payload['EcId'] = this.marksEntryForm.value['list'];

    if(this.FeeDetailForm.value['FeeType'] == 'AF'){
      // this.spinner.hide()
      this.getAdmListDownload()
    }
    else if(this.FeeDetailForm.value['FeeType'] == 'EF'){
      // this.spinner.hide()
      this.getExmListDownload()
    }
   
  
  }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }


  getAdmListDownload() {
    this.spinner.show()
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = submitpayload.CgCode;
    payload['CoCode'] = submitpayload.CoCode;
    payload['StuId'] = 0;
    payload2['FeeType'] = submitpayload.FeeType;
    payload2['SnNo'] = submitpayload.SnNo;
    payload2['CgCode'] = submitpayload.CgCode;
    payload2['CoCode'] = submitpayload.CoCode;

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.Table = true;
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];

          const extractedData = res.data.map(element => ({
           
            FeeTemplateCode: element.FeeTemplateCode,
            StudentId: element.StuId,
            StudentName: element.StuFirstNameEng + ' ' + element.StuMidNameEng + ' ' + element.StuLastNameEng,
            // StuMidNameEng: element.StuMidNameEng,
            // StuLastNameEng: element.StuLastNameEng,
            // TotalPaidAmount:element.TotalPaidAmount,
            TotalFee:element.FeeAmt,
            PaidAmount:element.TotalPaidAmount,
            College:element.CgName,
            Course:element.CoName,

          }));
      
          // Convert array data to CSV format
          const csvContent = this.convertArrayToCSV(extractedData);
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'paidData.csv'; // You can change the file name if needed
          document.body.appendChild(link);
      
          // Trigger the download
          link.click();

          // Call the second API for unpaid fees
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });

                const extractedUnpaidData = unpaidRes.data.map(element => ({
           
                  // FeeTemplateCode: element.FeeTemplateCode,
                  StudentRgNo: element.RgNo,
                  StudentName: element.StuFirstNameEng + ' ' + element.StuMidNameEng + ' ' + element.StuLastNameEng,
                  College:element.CgName,
                  Course:element.CoCode,
                  FeeTemplateCode: '-',
                  TotalFee:'-',
                  PaidAmount:'0',
                }));
                // Convert array data to CSV format for unpaid fee data
                const unpaidCsvContent = this.convertArrayToCSV(extractedUnpaidData);
                const unpaidBlob = new Blob([unpaidCsvContent], { type: 'text/csv;charset=utf-8;' });
                const unpaidUrl = window.URL.createObjectURL(unpaidBlob);
                const unpaidLink = document.createElement('a');
                unpaidLink.href = unpaidUrl;
                unpaidLink.download = 'unpaid_data.csv'; // Filename for unpaid data CSV
                document.body.appendChild(unpaidLink);
                unpaidLink.click();
    
                // Combine the data from both APIs
    
                this.FeeData = [...paidFeeData, ...unpaidFeeData];
                this.Table = true;
                this.spinner.hide();
              } else {
                this.FeeData = [...paidFeeData];
                this.Table = true;
                this.spinner.hide();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              this.spinner.hide();
              this.showErrorPopup(error.error.message);
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });

                const extractedUnpaidData = unpaidRes.data.map(element => ({
           
                  // FeeTemplateCode: element.FeeTemplateCode,
                  StudentRgNo: element.RgNo,
                  StudentName: element.StuFirstNameEng + ' ' + element.StuMidNameEng + ' ' + element.StuLastNameEng,
                  College:element.CgName,
                  Course:element.CoCode,
                  TotalFee:'-',
                  PaidAmount:'0',
                  FeeTemplateCode: '-',
      
                }));
                // Convert array data to CSV format for unpaid fee data
                const unpaidCsvContent = this.convertArrayToCSV(extractedUnpaidData);
                const unpaidBlob = new Blob([unpaidCsvContent], { type: 'text/csv;charset=utf-8;' });
                const unpaidUrl = window.URL.createObjectURL(unpaidBlob);
                const unpaidLink = document.createElement('a');
                unpaidLink.href = unpaidUrl;
                unpaidLink.download = 'unpaid_data.csv'; // Filename for unpaid data CSV
                document.body.appendChild(unpaidLink);
                unpaidLink.click();
    

                // Combine the data from both APIs
                this.FeeData = [...unpaidFeeData];
                this.Table = true;
                this.spinner.hide()
              } else {
                this.Table = false;
                this.spinner.hide()
                this.showNoDataFound();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              this.spinner.hide()
              this.showErrorPopup(error.error.message);
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide()
        this.showErrorPopup(error.error.message);
      }
    );
  }



  getExmListDownload(){
    this.spinner.show();
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = submitpayload.CgCode;
    payload['CoCode'] = submitpayload.CoCode;
    payload['StuId'] = 0;
    payload['EmId'] = submitpayload.EmId
    payload2['SessionId'] = submitpayload.SnNo;
    payload2['CoCode'] = submitpayload.CoCode;
    payload2['CgCode'] = submitpayload.CgCode;
    payload2['StuId'] = 0;
    payload2['FeeType'] = 'EF';
    payload2['EmId'] = submitpayload.EmId

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          // this.Table = true;
          this.spinner.hide();
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];
          const extractedData = res.data.map(element => ({
            StudentId: element.StuId,
            StudentName: element.StuFirstNameEng + ' ' + element.StuMidNameEng + ' ' + element.StuLastNameEng,
            College:element.CgName,
            Course:element.CoName,
            TotalFee:element.FeeAmt,
            PaidAmount:element.TotalPaidAmount,
            FeeTemplateCode: element.FeeTemplateCode,
            

          }));
      
          // Convert array data to CSV format
          const csvContent = this.convertArrayToCSV(extractedData);
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'paidDataExam.csv'; // You can change the file name if needed
          document.body.appendChild(link);
      
          // Trigger the download
          link.click();

          const paidStuIds = new Set(paidFeeData.map(item => item.StuId));

          // Call the second API for unpaid fees
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if(unpaidRes.status){
                
                const studentData = unpaidRes.data;

                // Filter out students already in paid fees
                const filteredUnpaidData = studentData.filter(record => !paidStuIds.has(record.StuId));
  
                const studentMap = new Map<number, any>();
                filteredUnpaidData.forEach(record => {
                  const key = record.StuId;
                  if (!studentMap.has(key)) {
                    studentMap.set(key, record);
                  }
                });
                  const FeeData = Array.from(studentMap.values()).map((item) => {
                    return {
                      ...item,
                      FeeAmt: '-',
                      TotalPaidAmount: item.TotalPaidAmount || 0, // Use existing value or default to 0
                      FeeTemplateCode: '-',
                    };
                  });
                  this.FeeData = [...paidFeeData,...FeeData];
                  this.Table = true

                  const extractedUnpaidData = Array.from(studentMap.values()).map(element => ({
                    StudentId: element.StuId,
                    StudentName: element.StuFirstNameEng + ' ' + element.StuMidNameEng + ' ' + element.StuLastNameEng,
                     College:element.CgCode,
                    Course:element.CoCode,
                    FeeAmount: element.FeeAmount,
                    TotalPaidAmount:0, // Use existing value or default to 0
                    FeeTemplateCode: '-',
                   }));
              
                  // Convert array data to CSV format
                  const csvUnpaidContent = this.convertArrayToCSV(extractedUnpaidData);
                  const blob = new Blob([csvUnpaidContent], { type: 'text/csv;charset=utf-8;' });
                  const url = window.URL.createObjectURL(blob);
                  const unpaidLink = document.createElement('a');
                  unpaidLink.href = url;
                  unpaidLink.download = 'unpaidDataExam.csv'; // You can change the file name if needed
                  document.body.appendChild(unpaidLink);
              
                  // Trigger the download
                  unpaidLink.click();
        
              }
              else{
                this.FeeData = [...paidFeeData];
                this.Table = true;
              }
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if(unpaidRes.status){
                this.spinner.hide();
                const studentData = unpaidRes.data;
                  const studentMap = new Map<number, any>();
                  studentData.forEach(record => {
                    const key = record.StuId;
                    if (!studentMap.has(key)) {
                      studentMap.set(key, record);
                    }
                  });
                  const FeeData = Array.from(studentMap.values()).map((item) => {
                    return {
                      ...item,
                      FeeAmt: '-',
                      TotalPaidAmount: item.TotalPaidAmount || 0, // Use existing value or default to 0
                      FeeTemplateCode: item.TemplateCode || '-',
                    };
                  });
                  this.FeeData = [...FeeData];
                  // this.TotalPaid = this.calculateTotalPaidAmount(this.FeeData);
                  this.Table = true
                  const extractedUnpaidData = Array.from(studentMap.values()).map(element => ({
                    StudentId: element.StuId,
                    StudentName: element.StuFirstNameEng + ' ' + element.StuMidNameEng + ' ' + element.StuLastNameEng,
                     College:element.CgCode,
                    Course:element.CoCode,
                    FeeAmount: element.FeeAmount,
                    TotalPaidAmount:0, // Use existing value or default to 0
                    FeeTemplateCode: '-',
                   }));
              
                  // Convert array data to CSV format
                  const csvUnpaidContent = this.convertArrayToCSV(extractedUnpaidData);
                  const blob = new Blob([csvUnpaidContent], { type: 'text/csv;charset=utf-8;' });
                  const url = window.URL.createObjectURL(blob);
                  const unpaidLink = document.createElement('a');
                  unpaidLink.href = url;
                  unpaidLink.download = 'unpaidDataExam.csv'; // You can change the file name if needed
                  document.body.appendChild(unpaidLink);
              
                  // Trigger the download
                  unpaidLink.click();
        

                  
              } else {
                this.Table = false;
                this.showNoDataFound();
                this.spinner.hide();
              }
            },
            (error: HttpErrorResponse) => {
              this.spinner.hide();
              this.Table = false;
              this.showErrorPopup(error.error.message);
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.Table = false;
        this.showErrorPopup(error.error.message);
      }
    );
   
  }
}
